<template>
	<div class="leaderboard base-text">
		<div class="header">
			<div class="header__sub-header">
				<FlappySackLogo />
				<div class="base-text header__presents">leaderboard</div>
			</div>
		</div>
		<!-- ME -->
		<div v-if="best" class="leaderboard__list-container">
			<div
				class="leaderboard__list-item list"
				v-for="(item, index) in 1"
				:key="index"
			>
				<div class="list__order center-box">ME</div>
				<div class="list__name">Best</div>
				<div
					v-if="scores.top[index] && scores.top[index].count"
					class="list__count center-box"
				>
					{{ best }}
				</div>
			</div>
		</div>

		<div class="leaderboard__list-container">Last 24 Hours</div>
		<Board :amount="3" :scores="scores.last24" :isLoaded="isLoaded"/>

		<div class="leaderboard__list-container">Stage 3</div>
		<Board :amount="3" :scores="scores.level3" :isLoaded="isLoaded"/>

		<div class="leaderboard__list-container">Stage 2</div>
		<Board :amount="3" :scores="scores.level2" :isLoaded="isLoaded"/>

		<div class="leaderboard__list-container">Stage 1</div>
		<Board :amount="3" :scores="scores.level1" :isLoaded="isLoaded"/>

		<div class="leaderboard__list-container">All Time High</div>
		<Board :amount="10" :scores="scores.top" :isLoaded="isLoaded"/>

	</div>
</template>

<script>
	import scoresService from '@/services/score';
	import FlappySackLogo from '@/components/svg/FlappySackLogo';
	import Board from '@/components/Board';

	export default {
		props: ['best'],
		async created() {
			let last24 = new Date().getTime() - 86400000;
			this.scores.top = await scoresService.v2.get.top();
			this.scores.last24 = await scoresService.v2.get.date(last24);
			this.scores.level1 = await scoresService.v2.get.level(1);
			this.scores.level2 = await scoresService.v2.get.level(2);
			this.scores.level3 = await scoresService.v2.get.level(3);
		},
		computed: {
			isLoaded() {
				return this.scores.top && this.scores.top.length;
			},
		},
		components: {
			FlappySackLogo,
			Board
		},
		data() {
			return {
				scores: {
					top: [],
					level1: [],
					level2: [],
					level3: [],
					last24: []
				},
			};
		},
	};
</script>

<style lang="scss">
	@import '@/styles/mixins';
	$border-width: 45px;

	.leaderboard {
		
		&__list-container {
			width: 85%;
			margin: 0 auto;
			max-width: 470px;
			padding-bottom: 20px;
		}
		&__list-item {
			width: 100%;
			height: auto;
			min-height: 60px;
			margin: 0 auto 10px auto;
			display: flex;
			align-items: center;
			@include outline;
			font-size: 18px;
		}
        .primary-list {
            $size: 40px;
            &:first-child {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    width: $size;
                    height: $size;
                    top: -$size / 2;
                    left: 50%;
                    margin-left: -$size / 2;;
                    background-image: url(../assets/moon.png);
                    background-size: 90%;
                    background-position: center;
                    background-repeat: no-repeat;
                }
            }
        }
		.list {
			position: relative;
			&__order {
				width: $border-width;
				position: absolute;
				height: 100%;
				border-right: 2px solid #fdb935;
				font-size: 24px;
			}
			&__name {
				width: 60%;
				margin-left: calc(#{$border-width} + 20px);
			}
			&__count {
				width: 20%;
			}
            &__level {
                min-width: 70px;
                min-height: 60px;
                background-position: center;
                background-size: 90%;
                background-repeat: no-repeat;
            }
		}
	}
</style>
